import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profileData: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfileData: (state, action) => {
      state.profileData = action.payload;
    },
    clearProfile: (state) => {
      state.profileData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("auth/logout", (state) => {
      state.profileData = null;
    });
  },
});

export const { setProfileData, clearProfile } = profileSlice.actions;
export default profileSlice.reducer;
